const Common = {
    //  api: 'http://127.0.0.1/sharework_back_v2/public/backend/',
    //  api: 'http://192.168.1.110/sharework_back_v2/public/backend/',
     api: 'https://share-work.jp/backend/',
}
// window.location.host = window.location.host+'/backend/';
if (window.location.host === 'localhost:8000') {
    Common.api = 'http://localhost:8000/backend/';
}
export default Common
